import React from 'react';
import { useHitlAvailability } from '../hooks/useHitlAvailability';

export default function HitlAvailabilityBoundary({ children }: { children: React.ReactNode }) {
  const availability = useHitlAvailability();
  if (availability.pending) {
    return <p role="status">Checking instructor support availability…</p>;
  }
  if (availability.error) {
    return (
      <section role="alert">
        <h1>Instructor support unavailable</h1>
        <p>We could not verify this environment&apos;s instructor support status. No queue or session actions have been opened.</p>
        <button type="button" onClick={() => void availability.retry()}>Retry availability check</button>
      </section>
    );
  }
  if (!availability.available) {
    return (
      <section>
        <h1>Instructor support unavailable</h1>
        <p>Live human takeover is not enabled in this environment. Other teaching tools remain available.</p>
      </section>
    );
  }
  return <>{children}</>;
}
